import { request } from 'src/api/request';

export const getProviderLists = async (queryParams: string) => {
  return await request({
    url: `/v1/provider-lists/lists/${queryParams}`, // accepts user_id
    method: 'GET',
  });
};

export const getProviderListMembers = async ({
  listId,
  queryParams,
  data,
}: {
  listId: string;
  queryParams: string;
  data: any;
}) => {
  return await request({
    url: `v1/provider-lists/lists/${listId}/members/${queryParams}`,
    method: 'POST',
    data,
  });
};

export const createList = async ({ listName }) => {
  if (!listName) return;
  return request({
    url: `/v1/provider-lists/lists/`,
    method: 'POST',
    data: {
      name: listName,
    },
  });
};

export const updateList = async ({ listId, listName, ownerId, sharedWith }) => {
  if (!listId) return;

  const newData = {};
  if (listName) newData['name'] = listName;
  if (ownerId) newData['owner_id'] = ownerId;
  if (sharedWith) newData['shared_user_ids'] = sharedWith;

  return request({
    url: `/v1/provider-lists/lists/${listId}/`,
    method: 'PATCH',
    data: newData,
  });
};

export const deleteList = async ({ listId }) => {
  if (!listId) return;

  return request({
    url: `/v1/provider-lists/lists/${listId}/`,
    method: 'DELETE',
  });
};

export const deleteListItem = async ({ listId, itemId }) => {
  if (!listId || !itemId) return;

  return request({
    url: `/v1/provider-lists/lists/${listId}/items/${itemId}/`,
    method: 'DELETE',
  });
};

export const uploadList = async ({ data }) => {
  return request({
    url: `v1/provider-lists/upload/`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
